module.exports = __webpack_public_path__ + "static/media/icon_165.a27b5e6c.svg";